var _rect, _path, _path2, _ellipse, _circle, _ellipse2, _circle2, _circle3, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 101,
    viewBox: "0 0 120 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.39844,
    width: 119,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0199 59.4122V65.1539C41.1371 65.7007 41.7933 66.8412 43.4807 67.0287H88.2424C88.8282 66.8725 90 66.2788 90 65.1539V54.9595L84.2583 45.5853C83.9068 45.1556 82.9225 44.3198 81.7976 44.4135H71.0173V59.4122H41.0199ZM74.6498 48.2804V55.7798H85.7816L81.0945 48.2804H74.6498Z",
    fill: "#F1453D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1345 39.3729V59.4102H39.3794C38.7154 59.4102 37.4108 59.0821 37.5046 57.7697C37.5983 56.4574 38.5592 55.8949 39.0279 55.7777H41.1371V51.9109H35.3954C34.8486 51.7156 33.7549 51.0438 33.7549 49.9189C33.7549 48.794 34.8486 48.2003 35.3954 48.044H41.1371V44.4115H31.2942C30.9427 44.4115 30.099 43.8725 30.0052 42.6539C29.9115 41.4352 31.0989 40.9743 31.6457 40.779H41.1371V38.787C41.3246 37.2871 42.7776 37.0684 43.4806 37.1465H69.1424C70.9235 37.709 71.2126 38.8651 71.1345 39.3729Z",
    fill: "#FDC02F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.9853,
    cy: 66.9136,
    rx: 5.74168,
    ry: 5.74169,
    fill: "#465A63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.8682,
    cy: 67.0311,
    r: 2.10919,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.6284,
    cy: 66.9136,
    rx: 5.74168,
    ry: 5.74169,
    fill: "#465A63"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5112,
    cy: 67.0311,
    r: 2.10919,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3701,
    cy: 41.249,
    r: 10.749,
    fill: "white",
    stroke: "#DCCECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9648 42.1561L56.4655 49.1825V41.7862C57.994 41.663 58.8076 40.4816 59.0233 39.9064C59.8615 37.4656 57.6673 36.0543 56.4655 36.1776V33.5273C59.0788 33.3547 60.7183 35.1401 61.2113 36.0543C62.7399 38.6676 61.6839 41.2111 60.9648 42.1561Z",
    fill: "#149D11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0098 42.1561L56.5092 49.1825V41.7862C54.9806 41.663 54.167 40.4816 53.9513 39.9064C53.1131 37.4656 55.3073 36.0543 56.5092 36.1776V33.5273C53.8959 33.3547 52.2564 35.1401 51.7633 36.0543C50.2348 38.6676 51.2908 41.2111 52.0098 42.1561Z",
    fill: "#0A8107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDelivery);
export default __webpack_public_path__ + "static/media/createDelivery.9b39e7924698768e81674a29d1ac10cd.svg";
export { ForwardRef as ReactComponent };